define('modules/header/header_view',[
  'backbone',
  'jquery',
  '_',

  'modules/user/user_model',
  'modules/modal/modal_view',
  'modules/header/modals/select_store_modal',
  'text!./header_template.html',
  'text!./header_user_template.html',
  'session'
],
  function (Backbone, $, _,
    user,
    ModalView,
    SelectStoreModal,
    header_template,
    header_user_template,
    session) {
    'use strict';
    var View = Backbone.View.extend({
      initialize: function (opts) {
        _.extend(this, opts);

        this.render();

        this.listenToOnce(user, 'change:display_name', function (user) {
          this.renderUser();
        }, this);

      },

      template: _.template(header_template),
      user_template: _.template(header_user_template),

      events: {
        'click .js-open-select-store-modal': 'openSelectStoreModal',
      },

      render: function () {
        this.$el.html(this.template());
        return this;
      },

      openSelectStoreModal: function (e) {
        e.preventDefault();

        $.ajax({
          type: 'GET',
          url: session.get('apiUrl') + 'btv/user/locations',
          contentType: 'application/json'
        })
          .success(function (data) {
            console.info(data);
            // Open modal when data is fetched from server.
            var modalView = new ModalView({
              title: _.t('header.select_store_modal.switch_store'),
              modalContent: new SelectStoreModal({
                stores: data.user_locations
              }),
              bottom_toolbar: false
            });
            modalView.subViews.push(modalView.modal);
            modalView.open();
          }.bind(this))
          .error(function (error) {
            console.error(error);
          }.bind(this));
      },

      renderUser: function () {
        this.$('.js-user').html(this.user_template({ display_name: user.get('display_name'), location_name: user.get('location').location_name }));
      },

      remove: function () {
        this.$el.empty();
        this.stopListening();
        this.$el.off();
        return this;
      }
    });
    return View;
  });

